const colors = {
  primary: {
    dark: "#806525",
    light: "#F9D209",
    default: "#E6B743",
    blue_100: "rgba(13,48,80,1)",
    blue_80: "rgba(13,48,80,0.8)",
  },
  secondary: {
    default: "#0d3050cc",
  },
  tertiary: {
    pink: "#E4A09F",
  },
  warning: {
    300: "#FEC84B",
  },
  success: {
    100: "#D1FADF",
    500: "#E8FCE9",
    600: "#A3F0A7",
    700: "#00C408",
    800: "#139E19",
    900: "#008005",
  },
  error: {
    500: "#FCEAE8",
    600: "#FCD2CF",
    800: "#9E241C",
    900: "#800C05",
  },
  neutrals: {
    100: "#FAFAFA",
    200: "#E6E6E6",
    300: "#D1D1D1",
    400: "#B8B8B8",
    500: "#A3A3A3",
    600: "#7A7A7A",
    700: "#525252",
    800: "#2E2E2E",
    900: "#0F0F0F",
  },
  Gray: {
    200: "#EAECF0",
    700: "#344054",
  },
  v2: {
    primary: {
      default: "#F9D209",
    },
    blue: {
      100: "rgba(13,48,80,1)",
      80: "rgba(13,48,80,0.8)",
    },
  },
};

export default colors;
